import { Plus, X } from "lucide-react";
import CustomInput from "../../../shared/CustomInput";
import Loading from "../../../shared/Loading";
import { useRef } from "react";
import { uploadImage } from "../../../sdk/upload/upload";

const EditBusinessLocation = ({
  closeEditBusinessLocation,
  editBusinessLocationDetails,
  setEditBusinessLocationDetails,
  loading,
  handleEditBusinessLocation,
}) => {
  const fileInputRef1 = useRef(null);
  const handleChooseFileClick1 = () => fileInputRef1.current?.click();

  const handleFileChange1 = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const response = await uploadImage(file);
      if (response?.url) {
        setEditBusinessLocationDetails((prev) => ({
          ...prev,
          businessImageUrl: response.url,
        }));
      }
    }
  };
  return (
    <div
      onClick={closeEditBusinessLocation}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[880px] h-[650px] overflow-y-auto rounded-[10px] p-[20px] relative bg-white"
      >
        <div
          onClick={closeEditBusinessLocation}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#D63B3B] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <p className="font-semibold text-[#000000] text-[16px] mb-2">
          Edit Business Location
        </p>
        <p className="text-[15px] font-medium text-[#5C5C5C] mb-4">
          Review and update the borrower's business address, type, and location
          details. Accurate information helps in proper loan assessment and
          follow-ups.
        </p>
        <div className="mb-[10px] w-[100%]">
          <label className="text-sm font-medium">Business Name</label>
          <CustomInput
            placeholder="e.g. http://"
            value={editBusinessLocationDetails.businessName}
            onChange={(e) =>
              setEditBusinessLocationDetails({
                ...editBusinessLocationDetails,
                businessName: e.target.value,
              })
            }
          />
        </div>
        <div className="flex justify-between mb-[10px] gap-4">
          <div className="w-[49%]">
            <label className="text-sm font-medium">Location Link</label>
            <CustomInput
              placeholder="e.g. http://"
              value={editBusinessLocationDetails.locationLink}
              onChange={(e) =>
                setEditBusinessLocationDetails({
                  ...editBusinessLocationDetails,
                  locationLink: e.target.value,
                })
              }
            />
          </div>
          <div className="w-[49%]">
            <label className="text-sm font-medium">Physical Address</label>
            <CustomInput
              placeholder="e.g. Dadora, Nairobi"
              value={editBusinessLocationDetails.physicalAddress}
              onChange={(e) =>
                setEditBusinessLocationDetails({
                  ...editBusinessLocationDetails,
                  physicalAddress: e.target.value,
                })
              }
            />
          </div>
        </div>
        <div className="mb-[10px] w-full">
          <label className="text-sm font-medium">Location Description</label>
          <textarea
            className="h-[75px] w-full text-[14px] rounded-[5px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9]"
            placeholder="e.g. Bahati district"
            value={editBusinessLocationDetails.locationDescription}
            onChange={(e) =>
              setEditBusinessLocationDetails({
                ...editBusinessLocationDetails,
                locationDescription: e.target.value,
              })
            }
          />
        </div>
        <p className="text-[15px] font-[#333333] font-medium">
          Business image(s)
        </p>
        <div className="w-full h-[130px] flex items-center gap-[10px]">
          <div className="h-full w-[180px] rounded-[15px] relative overflow-hidden">
            {editBusinessLocationDetails?.businessImageUrl ? (
              <>
                {/* Image */}
                <img
                  className="h-full w-full rounded-[15px] object-contain"
                  src={editBusinessLocationDetails?.businessImageUrl}
                  alt="businessImageUrl"
                />

                {/* View icon - top right */}
                <button
                  className="absolute top-2 right-2 bg-opacity-70 p-1"
                  onClick={() => console.log("View image")}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_1554_3633)">
                      <rect width="24" height="24" rx="5" fill="white" />
                      <path
                        d="M6.64084 17.3586L9.55058 17.372L9.54139 18.3627L5.63604 18.3634L5.63675 14.458L6.64084 14.4623V17.3586ZM6.64084 6.64024L6.64084 9.53655L5.63533 9.5408L5.63604 5.63545L9.54139 5.63615L9.55058 6.62681L6.64084 6.64024ZM17.3726 17.372L17.386 14.4623L18.364 14.4587V18.3634L14.4579 18.3634L14.4763 17.372H17.3726ZM17.3726 6.62681L14.4763 6.62681L14.4586 5.63615L18.364 5.63545V9.5415L17.386 9.53655L17.3726 6.62681Z"
                        fill="#5C5C5C"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1554_3633">
                        <rect width="24" height="24" rx="5" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </>
            ) : (
              <p className="text-[#333333] text-[13px] font-normal">
                No business location image
              </p>
            )}
          </div>

          <div
            onClick={handleChooseFileClick1}
            className="h-full bg-[#F3F3F3] w-[180px] cursor-pointer rounded-[15px] flex flex-col items-center justify-center"
          >
            <input
              type="file"
              ref={fileInputRef1}
              className="hidden"
              onChange={handleFileChange1}
            />
            <Plus size={24} color="#000" />
            <p className="text-center text-[10px] text-[#000]">
              Replace photo Drag and Drop files here or{" "}
              <span className="text-[#000000] underline">Choose file here</span>
            </p>
          </div>
        </div>
        <div className="absolute bottom-[20px] right-[20px] flex items-center justify-center gap-[10px]">
          <button
            onClick={closeEditBusinessLocation}
            className="h-[35px] bg-[#F3F3F3] rounded-[30px] px-[15px] text-[#5C5C5C] font-medium"
          >
            Close
          </button>
          <button
            onClick={handleEditBusinessLocation}
            disabled={loading}
            className="h-[35px] bg-[#000000] flex items-center justify-center gap-[5px] rounded-[30px] px-[15px] text-[#FFFFFF] font-medium"
          >
            {loading && <Loading />}
            Edit and Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditBusinessLocation;
